import {
    type ListStyleStruct as EditorListStyleStruct,
    type IAdvancedTextMaterial,
} from '@meitu/saas-editor-core/es/version-types';

export interface IThumbnail {
    width: number;
    height: number;
    url: string;
}

export interface BackgroundListItem {
    name: string;
    threshold: number;
    id: number;
    thumbnail: IThumbnail;
    zip_url: string;
    corner_mark: IThumbnail;
    picture_display_mode: number;
    thumbnail_width?: number;
    thumbnail_height?: number;
    type_id?: number;
    material_conf: {
        backgroundImagePath?: string;
        height: number;
        material: string;
        width: number;
    };
}

/**
 * @description 素材返回公用数据
 */
export interface MaterialListItem {
    /** 是否前端写死的素材 */
    is_preset?: boolean;
    /**
     * 素材名称
     */
    name: string;
    /**
     * 是否vip 1是 0否
     */
    threshold: number;
    /**
     * 素材id
     */
    id: number;
    /**
     * 缩略图
     */
    thumbnail: IThumbnail;
    /**
     * zip URL地址
     */
    zip_url?: string;
    /**
     * 角标地址
     */
    corner_mark: IThumbnail;
    type_id?: number;
    seed?: number;
    material_conf?: {
        backgroundImagePath: string;
        height: number;
        width: number;
    };
    svg?: {
        brush?: boolean;
        image: string;
        file: string;
        info: string;
    };
    type?: string;
    stick_type?: number;
}

export interface WatermarkListItem {
    // corner_mark: string;
    corner_mark_url: string;
    default_name: string;
    id: number;
    threshold: number;
    corner_mark: {
        url: string;
        width: number;
        height: number;
    };
    type_id: number;
    thumbnail: {
        width: number;
        height: number;
        url: string;
    };
    picture_display_mode: number;
    zip_file: {
        url: string;
    };
}

export interface MaterialTopicItem {
    /**
     * 分类ID
     */
    id: number | string;
    /**
     * 分类名称
     */
    name?: string;

    /** 下一页token */
    cursor?: string;
    /**
     * 素材列表
     */
    materials: MaterialListItem[] | BackgroundListItem[] | WatermarkListItem[];
    /**
     * cdn
     */

    seed?: number;
}

export interface ICategory {
    name?: string;
    id?: string | number;
}

export interface TextMaterialItem {
    category_id: number;
    /**
     * 字体名称
     */
    name: string;
    /**
     * 是否vip 1是 0否
     */
    threshold: number;
    /**
     * 素材id
     */
    id: number;
    /**
     * 缩略图
     */
    thumbnail: IThumbnail;
    /**
     * zip URL地址
     */
    zip_url?: string;
    /**
     * 新包的zip URL地址
     */
    zip_url_new?: string;
    /**
     * 角标地址
     */
    corner_mark: IThumbnail;
    corner_mark_id: number;
    default_name: string;
    type_id?: number;

    /**
     * 缩略图新版
     */
    preview_v3?: IThumbnail;
    /**
     * 推荐id
     */
    scm?: string;
}

export interface TextCategoryItem {
    /**
     * 分类ID
     */
    id: number | string;
    /**
     * 分类名称
     */
    name: string;
    /**
     * 素材列表
     */
    materials: TextMaterialItem[];
    /**
     * 是否展示icon
     */
    isShowIcon?: boolean;
}
export interface IColorItem {
    id: number;
    name: string;
    color: string;
}

export enum CollapseType {
    SHORTCUT_MENU = 'menuShortcut',
    TEMPLATE_MENU = 'menuTemplate',
    TEXT_MENU = 'menuText',
    MATERIAL_MENU = 'menuCustomMaterial',
    MINE_MENU = 'menuMine',
    BACKGROUND_MENU = 'menuBackground',
    BRAND_LIB_MENU = 'menuBrandLib',
    NAVIGATOR_MENU = 'menuNavigator',
    PHOTO_MENU = 'menuPhoto',
    TEAM_MENU = 'menuTeam',
    MORE_MENU = 'menuMore',
    BRUSH_MENU = 'menuBrush',
    MOG_MENU = 'menuMog',
    WATERMARK_MENU = 'watermark_menu',
    ADJUST_MENU = 'menuAdjust',
    ELEMENT_MENU = 'menuElement',
    ELIMINATE_MENU = 'menuEliminate',
    MATTING_MENU = 'menuMatting',
    QUALITY_MENU = 'menuQuality',
    PRODUCT_RETOUCHING_MENU = 'menuProductRetouching',
    GRID_COLLAGE_MENU = 'menuGridCollage',
    PRODUCT_COLLAGE_MENU = 'menuProductCollage',
    LAYER_MENU = 'menuLayer',
    BATCH_TEXT_MENU = 'menuBatchText',
    BATCH_WATERMARK_MENU = 'menuBatchWatermark',
    BATCH_MATTING_MENU = 'menuBatchMatting',
    BATCH_QUALITY_MENU = 'menuBatchQuality',
    BATCH_ELIMINATE_MENU = 'menuBatchEliminate',
    BATCH_CROP_SIZE_MENU = 'menuBatchCropSize',
    BATCH_AI_BG_MENU = 'menuBatchAiBg',
    EXPAND_IMAGE_MENU = 'menuExpandImage',
}

export type ListStyleStruct = EditorListStyleStruct & {
    thumbnail: {
        width: number;
        height: number;
        url: string;
    };
};

export type ArtTextStruct = {
    id: string;
    config: IAdvancedTextMaterial;
    cornerMark?: {
        url: string;
        width: number;
        height: number;
    };
    thumbnail: {
        width: number;
        height: number;
        url: string;
    };
};
